<template>
  <div> 
    <v-btn class="mt-4" @click.native="printOverallAsset">
      <v-icon>print</v-icon>
    </v-btn>
    <v-switch
        v-model="hideZero"
        inset
        class="mb-2"
        label="Major Assets"
      />
      <v-spacer/>
    <v-data-table :items="list" class="elevation" :headers="headers">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.asset }}</td>
        <!-- <td>{{ props.item['.key'] }}</td> -->
        <td>{{ props.item.type }}</td>
        <td>{{ props.item.category }}</td>
        <td>{{ props.item.depriciation ? `${props.item.depriciation}%` : '--' }}</td>
        <!-- { text: 'Opening WDV', value: 'openingBalance', sortable: false}, -->
        <td>{{ props.item.openingBalance || 0 | amount }}</td>
        <!-- { text: 'Addition', value: 'additionAmount', sortable: false}, -->
        <td>{{ props.item.totalAdditionAmount | amount }}</td>
        <!-- { text: 'Deletion', value: 'deletionAmount', sortable: false}, -->
        <td>{{ props.item.totalDeletionAmount | amount }}</td>
        <!-- { text: 'Total', value: 'totalAmount', sortable: false}, -->
        <td>{{ getTotalAmount(props.item) | amount }}</td>
        <!-- { text: 'Dep Amount (Business)', sortable: false}, -->
        <td>{{ getDepAmount(props.item, props.item.category) | amount }}</td>
        <!-- { text: 'Closing WDV', sortable: false} -->
        <td>{{ getClosingWdv(props.item)| amount }}</td>
        <td>
          <v-btn icon class="primary white--text" @click="openAssetDialog(props.item)">
            <v-icon dark> 
              remove_red_eye 
            </v-icon>
          </v-btn>
        </td>
        <td>
          <v-btn icon class="primary white--text" @click="openAssetEdit(props.item)">
            <v-icon dark> 
              edit 
            </v-icon>
          </v-btn>
        </td>
      </template>
      <template slot="no-data">No Assets to Show</template>
    </v-data-table>
    
    <v-dialog v-model="dialog" transition="dialog-bottom-transition">
      <v-toolbar card dark color="primary">
        <v-toolbar-title>{{ selectedAsset }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click.native="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table :items="selectedAssets" class="elevation" :headers="assetHeader">
        <template slot="items" slot-scope="props">
          <td class="primary--text font-weight-bold" v-html="renderDate(props.item.date)"></td>
          <!-- <td>{{ props.item['.key'] }}</td> -->
          <td><b class="font-weight-bold">{{ getFirmName(props.item.firm) }}  - {{ props.item.taxableGST_rate }} - {{ props.item.GST_type }} </b></td>
          <td>{{ props.item.openingBalance || 0 | amount }}</td>
          <!-- <td>{{ props.item.totalAmount || 0 | amount}}</td> -->
          <td>{{ props.item.taxableAmount || 0 | amount }}</td>
          <template 
            v-if="!props.item.isCredited">
            <td h3 class = "red--text text--darken-4">
              {{ props.item.totalAmount || 0 | amount}}
            </td>
            <td></td>
          </template>
          <template 
            v-if="props.item.isCredited">
            <td></td>
            <td h3 class = "green--text text--darken-4">
              {{ props.item.totalAmount || 0 | amount}}
            </td>
          </template>
          <!-- <td>{{new Date(props.item.date).toLocaleDateString('en-GB')}}</td> -->
          <td>{{ props.item.paymentType }}</td>
          <td>{{ props.item.remark}}</td>
          <td>
            <v-btn icon class="primary--text" @click="openAssetInvoiceEdit(props.item,false)">
              <v-icon dark>
                edit
              </v-icon>  
            </v-btn>
          </td>
        </template>
        <template slot="no-data">no record found</template>
      </v-data-table>
    </v-dialog> 

    <!-- Start of Edit Asset-->
    <v-dialog v-model="dialogEdit" persistent transition="dialog-bottom-transition">
      <v-toolbar card dark color="primary">
        <v-toolbar-title v-if="selectedAsset">{{ selectedAsset.asset }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click.native="dialogEdit = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card tile v-if="selectedAsset" >
        <v-card-text>
          <v-text-field 
            label="Name" 
            v-model="selectedAsset.asset">
          </v-text-field>
          
          <!-- asset category -->
          <v-select
              v-model="asset.category"
              :items="assetCategoryList"
              label="Asset Category"
              required
          />
          <!-- asset type -->
          <v-select
              v-if="asset.category"
              v-model="asset.type"
              :items="assetTypeList"
              label="Asset Type"
              required
          />
          <!-- asset Allocate depriciating % based on selected type -->
          <v-select
              v-if="asset.type && allowDepriciation"
              label="Allocate Depriciation % ?"
              v-model="asset.depriciation"
              :items="depriciationList"
          />

          <!-- <v-select
            v-bind:items="categotyList"
            v-model="selectedAsset.category" 
            label="asset Category"
          />
          <v-select 
            v-bind:items="underHeadList"
            v-model="selectedAsset.underHead" 
            label="UnderHead"
          /> -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="saveAsset()">Save</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End of Edit Asset -->

    <!-- Start of Asset Invoice Edit -->
    <v-dialog v-model="dialogEditInvoice" persistent transition="dialog-bottom-transition">
      <v-toolbar card dark color="primary">
        <v-toolbar-title v-if="isConfirm">Confirm asset</v-toolbar-title>
         <v-toolbar-title v-else>Edit asset</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click.native="dialogEditInvoice = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card tile v-if="selectedAssetInvoice" >
        <v-card-text>
          <v-radio-group v-model="selectedAssetInvoice.paymentType" row>
            <v-radio label="From Cash" value="cash"></v-radio>
            <v-radio label="From Bank Account" value="account"></v-radio>
          </v-radio-group>
          <v-menu
            v-model="datepicker"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
            >
            <v-text-field
              slot="activator"
              v-model="selectedAssetInvoice.date"
              label="Date"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker 
              v-model="selectedAssetInvoice.date"
              @input="datepicker = false"
            />
          </v-menu>
          <v-select
            class="select-firm"
            :items="firmsByBrand"
            label="Select Firm"
            v-model="selectedAssetInvoice.firm"
            ></v-select>
          <v-select 
            v-if="selectedAssetInvoice.paymentType == 'account'" 
            v-model="selectAccountFromasset"
            :items="banksByFirm"
            label="From Account"
            :disabled="!selectedAssetInvoice.firm"
            required
          >
            <template slot="selection" slot-scope="data">
              {{ data.item.accountnumber }}{{data.item.bankName ? ' | '+data.item.bankName : '' }}
            </template>
            <template slot="item" slot-scope="data">
              <v-list-tile-content>
                <v-list-tile-title v-html="`${data.item.accountnumber}
                  ${data.item.bankName ? ' | '+data.item.bankName : '' }
                  ${data.item.accountType ? ' | '+data.item.accountType : '' }`
                " />
              </v-list-tile-content>
            </template>
          </v-select>
          <v-text-field
            type="number"
            v-model="selectedAssetInvoice.openingBalance"
            label="Opening Balance"
          ></v-text-field>
          <v-text-field
            :value="selectedAsset"
            label="asset"
            v-if="isConfirm"
            :disabled="true"
          ></v-text-field>
          <v-text-field
            type="number"
            v-model="selectedAssetInvoice.totalAmount"
            label="Amount"
          ></v-text-field>
          <v-text-field
            v-model="selectedAssetInvoice.remark"
            label="Remark"
          ></v-text-field>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="saveAssetInvoice()"><span v-if="isConfirm">Confirm</span><span v-else>Save</span></v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- End of Asset Invoice Edit --> 

  </div>
</template>
<script>
import {
    ASSET_TYPE_WITH_DEPRICIATION,
    ASSET_CATEGORY,
    ASSET_PURCHASE_TYPE,
    PAYMENT_OPTIONS,
    getFinancialYear
} from '../tabs/utils';

import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
import { assetOverallReport } from "../../../utils/pdf-reports/assetOverallReport.js";

export default {
  name: "AssetTableInfo",
  props: {
    // selectedBrand: { type: String, default: '' },
    accountsByBrand: { type: Array },
    firmsByBrand: { type: Array },
    assetByBrand: {type: Array },
  },
  created() {
    this.$bindAsArray("assets", this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand","finYear","brandFinYear"]),
    assetTypeList() { return ASSET_TYPE_WITH_DEPRICIATION},
    assetCategoryList() { return ASSET_CATEGORY },
    assetPurchaseType() { return ASSET_PURCHASE_TYPE },
    list() {
      if (this.assets) {
        let selectedAssets = this.assets.filter(asset => {
          return asset.brand === this.selectedBrand;
        });
        selectedAssets.map((ast,index)=>{
          let firmAsset = this.invoices.filter(item => 
             item['assetType'] === ast['.key']
             && item['brand'] === this.selectedBrand
             && (item.date >= this.finYear.start) && (item.date <= this.finYear.end)
            )
            let openingBalance = 0;
            firmAsset.map((inv)=>{
                openingBalance += (inv.openingBalance ? parseInt(inv.openingBalance) : 0);
            });
            selectedAssets[index]['openingBalance'] = openingBalance;
        })
        return selectedAssets;
      }
      return [];
    },
    allowDepriciation() {
            const list = this.assetTypeList.find(item => item.value === this.asset.type)
            if(list) {
                return !!list.depriciation
            }
            return false
    },
    depriciationList() {
      const list = this.assetTypeList.find(item => item.value === this.asset.type)
        if(list && list.depriciation !== false) {
          return list.depriciation
        }
      return []
    },
  },
  data() {
    return {
      asset: {},
      selectedAsset : [],
      selectedAssetInvoice : {},
      selectAccountFromAsset:null,
      isConfirm : false,
      datepicker : false,
      headers: [
        { text: "Name", value: "asset", sortable: true },
        // { text: "Id", value: ".key", sortable: false },
        { text: "Type", value: "type", sortable: true },
        { text: "Category", value: "category", sortable: false },
        { text: "Dep %", value: "depriciation", sortable: false },
        { text: "Opening WDV", value: "openingBalance", sortable: false },
        { text: "Addition", value: "additionAmount", sortable: false },
        { text: "Deletion", value: "deletionAmount", sortable: false },
        { text: "Total", value: "totalAmount", sortable: false },
        { text: "Dep Amount", sortable: false },
        { text: "Closing WDV", value: "closingAmount", sortable: false },
        { text: "View", sortable: false },
        { text: "Edit", sortable: false}
      ],
      assetHeader: [
        { text: "Date", value: "date", sortable: true },
        // { text: "Id", value: ".key", sortable: false },
        { text: "Firm", value: "firm", sortable: true },
        { text: "Opening WDV", value: "openingBalance", sortable: false },
        // { text: "totalAmount", value: "depriciation", sortable: false },
        { text: "Addition", value: "additionAmount", sortable: false },
        { text: "Deletion", value: "deletionAmount", sortable: false },
        { text: "Payment Type", value: ".key", sortable: false },
        { text: "Remark", value: "type", sortable: true },
        { text: "Action", value: "action", sortable: true },
      ],
      dialog : false,
      dialogEdit : false,
      dialogEditInvoice: false,
      selectedAssets :[],
    };
  },
  methods: {
    async printOverallAsset(asset){
      let firm  =this.firms.filter(item => item['.key'] === asset['firm'])[0];
      await assetOverallReport({
        // school: this.schools.filter((item) => item.id == this.defaultSchool)[0],
        firm : this.firm,        
        list : this.list,
      }).then((doc) => {
        pdfMake.createPdf(doc).download('ASSET_REPORT_' + new Date ().toLocaleDateString('en-GB'));
      });
    }, 
    getDepAmount(asset, type) {
      let depriciation = null;
      if (asset.isVerified && asset.depriciation) {
        const totalAmount = this.getTotalAmount(asset);
        depriciation = Number((totalAmount * asset.depriciation) / 100);
        return depriciation;
      }
      return 0;
    },
    getClosingWdv(asset) {
      return (
        (this.getTotalAmount(asset) + Number.parseFloat(asset.openingBalance || 0)) - this.getDepAmount(asset, asset.category)
      );
    },
    getTotalAmount(asset) {
      // if (asset.isVerified) {
      //   return (
      //     Number(asset.openingBalance || 0) +
      //     Number(asset.totalAdditionAmount) -
      //     Number(asset.totalDeletionAmount)
      //   );
      // }
      // return (
      //   Number(asset.totalAdditionAmount) - Number(asset.totalDeletionAmount)
      // );
       let total = 0;
      this.invoices.filter(invoice => {
        return (
          invoice.brand === this.selectedBrand &&
          invoice.transactionType === "Asset" &&
          invoice.assetType == asset[".key"] 
        );
      }).map((i)=>{
        console.log(i)
        total +=Number.parseFloat(i.totalAmount)}
      )
     return total;
      
    },  
    openAssetDialog(asset) {
      let invoice = this.invoices.filter(invoice => {
        return (
          invoice.brand === this.selectedBrand &&
          invoice.transactionType === "Asset" &&
          invoice.assetType == asset[".key"] && 
          (invoice.date >= this.finYear.start) && (invoice.date <= this.finYear.end)
        );
      });
      console.log(invoice)
      invoice.sort(function(a,b){
        return -(new Date(b.date) - new Date(a.date));
      });
      this.selectedAssets = invoice;
      this.selectedAsset = asset["asset"];
      this.dialog = true;
    },
    getFirmName(e){
      let firm;
        if (this.firms && this.selectedBrand) {
          firm =this.firms.filter(item => item['.key'] === e)[0]
        }
      if(firm)
        return firm.name
    },
    renderDate(timeStamp) {
      if(timeStamp) {
          return new Date(timeStamp).toLocaleDateString('en-GB')
      }
      return '--'
    },
    saveAsset() {
      let key = this.selectedAsset['.key'];
      delete  this.selectedAsset['.key'];
      this.$root.$firebaseRefs.assets.child(key).update(this.selectedAsset).then((snap) => {
        this.dialogEdit = false;
      });
    },
    saveAssetInvoice(){
      this.selectedAssetInvoice.date = new Date(this.selectedAssetInvoice.date).getTime()
          if(this.selectedAssetInvoice.paymentType == 'cash' && this.isConfirm){
              this.$root.$firebaseRefs.firm.child(this.selectedAssetInvoice.firm).once('value').then((snap) => {
                  if(Number(snap.val().amount) >= this.selectedAssetInvoice.totalAmount){
                      this.$root.$firebaseRefs.firm.child(this.selectedAssetInvoice.firm).update({
                          amount: Number(snap.val().amount) - Number(this.selectedAssetInvoice.totalAmount)
                      });
                      setTimeout(() => {
                        let key = this.selectedAssetInvoice['.key'];
                        delete this.selectedAssetInvoice['.key'];
                        this.selectedAssetInvoice['paymentTypeStatus'] = 'confirm';
                        this.$root.$firebaseRefs.invoice.child(key).update(this.selectedAssetInvoice, ()=>{
                          this.selectedAssetInvoice.isCredited = true;
                          this.$root.$firebaseRefs.provisionAsset.push(this.selectedAssetInvoice)
                          this.dialogEditInvoice = false;
                        })
                        
                      })
                  } else{
                      console.log('Insufficient Balance')
                      
                  }
              })
          } else if(this.selectedAssetInvoice.paymentType == 'account' && this.isConfirm) {
              let assetAccountFirm= null;
              let assetAccountNumber =null;
              this.$root.$firebaseRefs.account.child(this.selectAccountFromAsset['.key']).once('value').then(snap => {
                  this.selectedAssetInvoice['accountNumber'] =  snap.val().accountnumber;
                  this.selectedAssetInvoice['bank'] =  this.selectAccountFromAsset['.key'];
                  if(Number(snap.val().amount) >= this.selectedAssetInvoice.totalAmount){
                      this.$root.$firebaseRefs.account.child(this.selectAccountFromAsset['.key']).update({
                          amount: Number(snap.val().amount) - Number(this.selectedAssetInvoice.totalAmount)
                      });
                      console.log( "asset amount paid");
                       setTimeout(() => {
                        let key = this.selectedAssetInvoice['.key'];
                        delete this.selectedAssetInvoice['.key'] 
                        this.selectedassetInvoice['paymentTypeStatus'] = 'confirm';
                        this.$root.$firebaseRefs.invoice.child(key).update(this.selectedAssetInvoice, ()=>{
                          this.selectedAssetInvoice.isCredited = true;
                          this.$root.$firebaseRefs.provisionAsset.push(this.selectedAssetInvoice)
                          this.dialogEditInvoice = false;
                        })
                      })
                  } else{
                      console.log('Insufficient Balance');
                  }
              })
          } else {
            let key = this.selectedAssetInvoice['.key'];
            delete this.selectedAssetInvoice['.key'] 
            this.$root.$firebaseRefs.invoice.child(key).update(this.selectedAssetInvoice).then((snap) => {
                this.selectedAssetInvoice['.key'] = key;
                this.dialogEditInvoice = false;
            });
          }
    },
    openAssetEdit(asset) {
      this.selectedAsset = asset
      this.dialogEdit = true;
    },
    openAssetInvoiceEdit(invoice,confirmDialog) {
      this.selectedAssetInvoice = invoice;
      this.selectedAssetInvoice.date = new Date(this.selectedAssetInvoice.date).toISOString("en-GB").substr(0, 10)
      this.dialogEditInvoice = true;
      this.isConfirm = confirmDialog;
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/InvoiceManagement/table/assetTable.vue